import { z } from 'zod';

const RuntimeConfigSchema = z.strictObject({
  apiOrigin: z.url(),
  /**
   * P8 R4 (Proposal, to be validated): shows the Confirmation execution mode on E5 and E7. A
   * string because nginx writes it into a quoted value, like `apiOrigin`. Absent means off, so
   * an image without the variable hides the mode. Any other value (an unreplaced
   * `${CONFIRMATION_MODE_ENABLED}` included) stops the boot instead of being guessed.
   */
  confirmationModeEnabled: z
    .enum(['true', 'false'])
    .optional()
    .transform((value) => value === 'true'),
});

/** Per-environment settings served at `/config.js` (standards §6). */
export type RuntimeConfig = z.infer<typeof RuntimeConfigSchema>;

/** The window as seen by {@link readRuntimeConfig}. */
export interface RuntimeConfigWindow {
  __FXMATE_CONFIG__?: unknown;
}

/**
 * Reads the config that `/config.js` puts on `window` at container start, so one image
 * runs in every environment.
 *
 * @throws {z.ZodError} when it is missing or invalid: better to stop at boot than to
 * call the wrong API.
 */
export function readRuntimeConfig(win: RuntimeConfigWindow): RuntimeConfig {
  return RuntimeConfigSchema.parse(win.__FXMATE_CONFIG__);
}
